import { Grid } from '@mui/material';
import React from 'react'
import PrivacyPolicy from './PrivacyPolicy';

function PrivacyPolicyAll() {
  return (
    <Grid>
        <PrivacyPolicy/>
    </Grid>
  )
}
export default PrivacyPolicyAll;